import { use } from "react";

import { SessionContext } from "@/lib/auth/context";

/**
 * A hook that provides access to the current session context.
 * Must be used within a SessionProvider component.
 *
 * @throws {Error} If used outside of a SessionProvider
 * @returns {SessionContext} The current session context
 *
 * @example
 * ```tsx
 * const { user, isAuthenticated } = useSession();
 * ```
 */
export function useSession(): SessionContext {
  const context = use(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }

  return context;
}
